"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcFormField_1 = require("../../form/AcFormField");
exports.AcPdfSetPhraseInputs = function (_a) {
    var setPhrase = _a.setPhrase, setSetPhrase = _a.setSetPhrase, setPhraseError = _a.setPhraseError, setSetPhraseError = _a.setSetPhraseError;
    var setPhraseOnChange = function (_, value) {
        if (value.length === 0) {
            setSetPhraseError({ empty: true, length: false, duplicated: false });
        }
        else if (value.length > 255) {
            setSetPhraseError({ empty: false, length: true, duplicated: false });
        }
        else {
            setSetPhraseError({ empty: false, length: false, duplicated: setPhraseError.duplicated });
        }
        setSetPhrase(value);
    };
    var setPhraseOnBlur = function () {
        setSetPhraseError({
            empty: setPhraseError.empty,
            length: setPhraseError.length,
            duplicated: false,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("form", null,
            react_1.default.createElement(AcFormField_1.AcFormField, { type: "textarea", rows: 30, value: setPhrase, onBlur: setPhraseOnBlur, onChange: setPhraseOnChange, invalid: setPhraseError.empty || setPhraseError.length || setPhraseError.duplicated, errorId: setPhraseError.empty
                    ? ''
                    : setPhraseError.length
                        ? '定型文は255文字以内でご入力ください'
                        : 'この定型文はすでに登録されています', placeholder: "\u5B9A\u578B\u6587\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" }))));
};
exports.AcPdfSetPhraseInputs.displayName = 'AcPdfSetPhraseInputs';
//# sourceMappingURL=AcPdfSetPhraseInputs.js.map